/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { FacilityServiceAreaStatus } from './FacilityServiceAreaStatus';
import {
    FacilityServiceAreaStatusFromJSON,
    FacilityServiceAreaStatusFromJSONTyped,
    FacilityServiceAreaStatusToJSON,
    FacilityServiceAreaStatusToJSONTyped,
} from './FacilityServiceAreaStatus';
import type { CreateLeadInfoRequestState } from './CreateLeadInfoRequestState';
import {
    CreateLeadInfoRequestStateFromJSON,
    CreateLeadInfoRequestStateFromJSONTyped,
    CreateLeadInfoRequestStateToJSON,
    CreateLeadInfoRequestStateToJSONTyped,
} from './CreateLeadInfoRequestState';

/**
 * 
 * @export
 * @interface FacilityServiceArea
 */
export interface FacilityServiceArea {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * A 5-digit US ZIP code (e.g. "10001").
     */
    zip: string;
    /**
     * 
     */
    city?: string;
    /**
     * 
     */
    state_id?: string;
    /**
     * 
     */
    state?: CreateLeadInfoRequestState;
    /**
     * 
     */
    status: FacilityServiceAreaStatus;
    /**
     * 
     */
    notes?: string;
    /**
     * 
     */
    created_by_user_id?: string;
    /**
     * 
     */
    updated_by_user_id?: string;
    /**
     * Full name of the user who created this record, when known.
     */
    created_by_name?: string;
    /**
     * Full name of the user who last updated this record, when known.
     */
    updated_by_name?: string;
    /**
     * 
     */
    date_created?: Date;
    /**
     * 
     */
    date_modified?: Date;
}



/**
 * Check if a given object implements the FacilityServiceArea interface.
 */
export function instanceOfFacilityServiceArea(value: object): value is FacilityServiceArea {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function FacilityServiceAreaFromJSON(json: any): FacilityServiceArea {
    return FacilityServiceAreaFromJSONTyped(json, false);
}

export function FacilityServiceAreaFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityServiceArea {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': json['facility_id'],
        'zip': json['zip'],
        'city': json['city'] == null ? undefined : json['city'],
        'state_id': json['state_id'] == null ? undefined : json['state_id'],
        'state': json['state'] == null ? undefined : CreateLeadInfoRequestStateFromJSON(json['state']),
        'status': FacilityServiceAreaStatusFromJSON(json['status']),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'created_by_user_id': json['created_by_user_id'] == null ? undefined : json['created_by_user_id'],
        'updated_by_user_id': json['updated_by_user_id'] == null ? undefined : json['updated_by_user_id'],
        'created_by_name': json['created_by_name'] == null ? undefined : json['created_by_name'],
        'updated_by_name': json['updated_by_name'] == null ? undefined : json['updated_by_name'],
        'date_created': json['date_created'] == null ? undefined : (parseDateTime(json['date_created'])),
        'date_modified': json['date_modified'] == null ? undefined : (parseDateTime(json['date_modified'])),
    };
}

export function FacilityServiceAreaToJSON(json: any): FacilityServiceArea {
    return FacilityServiceAreaToJSONTyped(json, false);
}

export function FacilityServiceAreaToJSONTyped(value?: FacilityServiceArea | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'zip': value['zip'],
        'city': value['city'],
        'state_id': value['state_id'],
        'state': CreateLeadInfoRequestStateToJSON(value['state']),
        'status': FacilityServiceAreaStatusToJSON(value['status']),
        'notes': value['notes'],
        'created_by_user_id': value['created_by_user_id'],
        'updated_by_user_id': value['updated_by_user_id'],
        'created_by_name': value['created_by_name'],
        'updated_by_name': value['updated_by_name'],
        'date_created': value['date_created'] == null ? value['date_created'] : serializeDateTime(value['date_created']),
        'date_modified': value['date_modified'] == null ? value['date_modified'] : serializeDateTime(value['date_modified']),
    };
}

